/* Popcorn & Pépites — les petites animations des sections de vente (sans dépendance). */
(() => {
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Apparition au défilement, et titres révélés mot à mot.
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } }), { threshold: 0.15 });
  const splitWords = (t) => (t.innerHTML = t.innerHTML.split(/(\s+)/).map((p) => (/^\s+$/.test(p) || !p ? p : `<span class="w">${p}</span>`)).join(""));
  document.querySelectorAll(".pp-words").forEach((el) => {
    if (el.dataset.split) return;
    const parts = el.querySelectorAll(".pp-d, .pp-m");
    (parts.length ? [...parts] : [el]).forEach(splitWords);
    el.dataset.split = "1";
    el.querySelectorAll(".w").forEach((w, i) => (w.style.transitionDelay = `${(i % 14) * 45}ms`));
  });
  document.querySelectorAll(".pp-reveal, .pp-stagger, .pp-words").forEach((el) => io.observe(el));

  // Chiffres qui comptent.
  const cio = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return; cio.unobserve(e.target);
    const el = e.target, to = +el.dataset.count, suffix = el.dataset.suffix || "", t0 = performance.now();
    const step = (t) => { const k = Math.min(1, (t - t0) / 1200), v = Math.round(to * (1 - Math.pow(1 - k, 3))); el.textContent = v + suffix; if (k < 1) requestAnimationFrame(step); };
    reduced ? (el.textContent = to + suffix) : requestAnimationFrame(step);
  }), { threshold: 0.5 });
  document.querySelectorAll("[data-count]").forEach((el) => cio.observe(el));

  // Cartes projecteur : le halo suit la souris.
  document.querySelectorAll(".pp-spot").forEach((c) => c.addEventListener("pointermove", (ev) => { const r = c.getBoundingClientRect(); c.style.setProperty("--mx", `${ev.clientX - r.left}px`); c.style.setProperty("--my", `${ev.clientY - r.top}px`); }));

  // Le mini tableau du héros : un tap, la pépite s'envole vers le bocal.
  const COLS = ["#F0B429", "#EF6F52", "#1F9E9A", "#7C6FE0", "#2E9E6B"];
  const fly = (from, to) => {
    if (reduced) return;
    const a = from.getBoundingClientRect(), b = to.getBoundingClientRect();
    for (let i = 0; i < 3; i++) {
      const f = document.createElement("div"); f.className = "pp-fly"; document.body.appendChild(f);
      const sx = a.right - 34, sy = a.top + a.height / 2 - 11, ex = b.left + b.width / 2 - 11, ey = b.top + 8;
      f.animate([{ transform: `translate(${sx}px,${sy}px) scale(1)` }, { transform: `translate(${(sx + ex) / 2}px,${Math.min(sy, ey) - 70}px) scale(1.2)`, offset: .5 }, { transform: `translate(${ex}px,${ey}px) scale(.5)` }], { duration: 650, delay: i * 90, easing: "cubic-bezier(.3,.7,.3,1)", fill: "both" }).onfinish = () => f.remove();
    }
    for (let i = 0; i < 12; i++) {
      const s = document.createElement("div"); s.className = "pp-spark"; s.style.background = COLS[i % 5]; document.body.appendChild(s);
      const x = a.left + 30, y = a.top + a.height / 2, ang = Math.random() * Math.PI * 2, d = 30 + Math.random() * 50;
      s.animate([{ transform: `translate(${x}px,${y}px)`, opacity: 1 }, { transform: `translate(${x + Math.cos(ang) * d}px,${y + Math.sin(ang) * d}px) rotate(${Math.random() * 360}deg)`, opacity: 0 }], { duration: 600 + Math.random() * 300, easing: "ease-out", fill: "both" }).onfinish = () => s.remove();
    }
  };
  document.querySelectorAll(".pp-screen").forEach((screen) => {
    const jar = screen.querySelector(".pp-jar"), count = screen.querySelector(".pp-count"), niveaux = screen.querySelectorAll(".pp-niv");
    const compagnon = screen.querySelector(".pp-compagnon");
    let n = 0;
    // Le bocal illustré : une image par niveau (0 à 5), la bonne s'affiche. Le compagnon éclot à la première pépite.
    const paint = () => {
      count.textContent = n;
      niveaux.forEach((img, i) => img.classList.toggle("on", i === Math.min(n, niveaux.length - 1)));
      if (compagnon) compagnon.classList.toggle("eclos", n > 0);
    };
    const tap = (btn) => {
      if (btn.classList.contains("done")) { btn.classList.remove("done"); n = Math.max(0, n - +btn.dataset.v); paint(); return; }
      btn.classList.add("done"); n += +btn.dataset.v; fly(btn, jar);
      setTimeout(() => { paint(); jar.classList.remove("pp-bump"); void jar.offsetWidth; jar.classList.add("pp-bump"); }, 560);
    };
    screen.querySelectorAll(".pp-task").forEach((b) => b.addEventListener("click", () => tap(b)));
    paint();
    // Démo automatique, une fois, quand le tableau entre à l'écran.
    const dio = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return; dio.disconnect();
      const tasks = [...screen.querySelectorAll(".pp-task")];
      tasks.forEach((b, i) => setTimeout(() => { if (!b.classList.contains("done")) tap(b); }, 900 + i * 1100));
    }), { threshold: 0.6 });
    dio.observe(screen);
  });

  // Les fiches superposées : un tap ou une pastille amène la fiche devant ; défilement doux tant qu'on n'a pas touché.
  document.querySelectorAll("[data-pp-fiches]").forEach((root) => {
    const cards = [...root.querySelectorAll(".pp-fiche")], chips = [...root.querySelectorAll(".pp-fiche-chip")];
    if (!cards.length) return;
    let a = 0, timer = 0, touched = false;
    const paint = () => {
      cards.forEach((c, i) => { const d = (i - a + cards.length) % cards.length; c.style.setProperty("--d", d); c.classList.toggle("on", d === 0); c.setAttribute("aria-hidden", d !== 0); });
      chips.forEach((c, i) => { c.classList.toggle("on", i === a); c.setAttribute("aria-pressed", i === a); });
    };
    const go = (i) => { a = (i + cards.length) % cards.length; paint(); };
    const stop = () => { touched = true; clearInterval(timer); };
    cards.forEach((c, i) => c.addEventListener("click", () => { stop(); go(i === a ? a + 1 : i); }));
    chips.forEach((c, i) => c.addEventListener("click", () => { stop(); go(i); }));
    paint();
    const fio = new IntersectionObserver((es) => es.forEach((e) => { clearInterval(timer); if (e.isIntersecting && !touched && !reduced) timer = setInterval(() => go(a + 1), 3200); }), { threshold: 0.4 });
    fio.observe(root);
  });

})();

/* Les articles du blog : sommaire, temps de lecture, ancres, tableaux qui défilent. */
(() => {
  const slug = (t) => t.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60);
  document.querySelectorAll(".pp-article").forEach((art) => {
    art.querySelectorAll("table").forEach((t) => {
      if (t.parentElement.classList.contains("pp-a-tablewrap")) return;
      const w = document.createElement("div"); w.className = "pp-a-tablewrap";
      t.replaceWith(w); w.appendChild(t);
    });
    const hs = [...art.querySelectorAll("h2")].filter((h) => !h.closest(".pp-a-tldr, .pp-a-cta"));
    hs.forEach((h) => { if (!h.id) h.id = slug(h.textContent); });
    const mots = art.textContent.trim().split(/\s+/).length;
    const min = Math.max(2, Math.round(mots / 220));
    const time = document.createElement("p");
    time.className = "pp-a-time";
    time.innerHTML = `<span aria-hidden="true">⏱️</span> ${min} min de lecture · ${mots.toLocaleString("fr-FR")} mots`;
    if (hs.length >= 3) {
      const nav = document.createElement("nav");
      nav.className = "pp-a-toc";
      nav.setAttribute("aria-label", "Sommaire");
      nav.innerHTML = `<b>Au sommaire</b><ol>${hs.map((h) => `<li><a href="#${h.id}">${h.textContent}</a></li>`).join("")}</ol>`;
      const tldr = art.querySelector(".pp-a-tldr");
      if (tldr) tldr.after(nav); else hs[0].before(nav);
      nav.before(time);
    } else {
      art.prepend(time);
    }
  });

  // Les encarts des articles (.pp-a-cta) sont écrits à la main dans Shopify : on ajoute le badge
  // Google Play à côté de chaque bouton qui ouvre le tableau, sans toucher aux articles.
  const tpl = document.getElementById("pp-play-tpl");
  if (tpl) {
    const racine = (h) => (h || "").replace(/^https?:\/\//, "").split(/[?#]/)[0].replace(/\/+$/, "") === "tableau.popcornetpepites.fr";
    document.querySelectorAll(".pp-a-cta a[href]").forEach((a) => {
      if (!racine(a.getAttribute("href")) || a.classList.contains("pp-play")) return;
      if (a.nextElementSibling && a.nextElementSibling.classList.contains("pp-play")) return;
      const badge = tpl.content.firstElementChild;
      if (badge) a.after(badge.cloneNode(true));
    });
  }
  // Le prix du pack dans ces mêmes encarts (19 € depuis le 22/10/2026) : corrigé à l'affichage
  // tant que les articles n'ont pas été repris à la main.
  document.querySelectorAll(".pp-a-cta a[href*='le-pack-papier']").forEach((a) => { if (/29 ?€/.test(a.textContent)) a.textContent = a.textContent.replace(/29 ?€/, "19 €"); });
})();
